/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\Offers\OfferTabs\offerTabs.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Monday July 8th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday July 8th 2024 2:38:12 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Tab, Tabs } from "@mui/material"
import { CustomTabPanel } from "Content/Stats/Stats";
import translator from "MultiLanguage/TranslationWrapper"
import { indexOf } from "lodash-es";
import { SyntheticEvent, useMemo, useState } from "react";
import { useLoaderData } from "react-router-dom";
import OfferTable from "../OfferTable/OfferTable";

export default function OfferTabs() {
    const loadData = useLoaderData() as {tabkey?: string};
    const tabIdx = ["all", "pending", "accepted", "archived", "cancel"];
    const [value, setValue] = useState(loadData.tabkey ? indexOf(tabIdx, loadData.tabkey) : 0);

    const handleChange = (event: SyntheticEvent, idx: number) => {
        setValue(idx);
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("tabkey", tabIdx[idx]);
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    };

    const buildTabs = () => {
        const tabs: JSX.Element[] = [];
        for (let i = 0; i < tabIdx.length; ++i)
            tabs.push(<Tab key={`${tabIdx}_${Math.random()}`} value={i} label={translator.decode(`Status.${tabIdx[i]}`)} />);
        return tabs;
    };

    const buildRows = () => {
        const rows: JSX.Element[] = [];
        for (let i = 0; i < tabIdx.length; ++i)
            rows.push(<CustomTabPanel key={`tabPanel-${tabIdx[i]}`} value={value} index={i} idlabel={""} aria={""} >
                <OfferTable showUser={true} Status={tabIdx[i]} />
            </CustomTabPanel>);
        return rows;
    };
    const offerPages = useMemo(() => {
        return buildRows();
    }, [value]);

    return (
        <>
            <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" textColor="primary" indicatorColor="primary" >
                {buildTabs()}
            </Tabs>
            {offerPages}
        </>
    );
};
